import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { head, tail, length, isEmpty, map as map_1, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Entity, DomainEntity, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useOptionalFetch_Static_5B82200F, useFeliz_React__React_useFetch_Static_6ADA66EC } from "../hooks/UseFetch.fs.js";
import { single } from "../Api/Users.fs.js";
import { single as single_1 } from "../Api/Disciplines.fs.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { EPM_Domain_Events_Maturity__Maturity_ToProperString } from "../Prelude.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { adminContent, ByCell, dateTimeCell, Labels, EntityName } from "./Prelude.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/Systems.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, RemoveSystemOwner, SetSystemOwner, AssignStatus, AssignProductionUnit, Update } from "../Modals/System.fs.js";
import { Components_UnDelete, Components_Delete, Components_ChangeAttributes, Components_ChangeLabels } from "../Modals/Modal.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(detail) {
    if (isNullOrWhiteSpace(detail)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["deleted", detail]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["labels"]);
    }
    else {
        return new FSharpResult$2(0, [["labels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function productionUnitParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["productionUnitId"]);
    }
    else {
        return new FSharpResult$2(0, [["productionUnitId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("status", "Status", undefined), new Column("productionUnit", "Production Unit", new FilterType(1, [projectId, new DomainEntities(13, []), empty(), productionUnitParam])), new Column("systemOwners", "System Owners", undefined), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(1, []), empty(), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function SystemOwner(systemOwnerInputProps) {
    const owner = systemOwnerInputProps.owner;
    const projectId = systemOwnerInputProps.projectId;
    const userFetched = useFeliz_React__React_useFetch_Static_6ADA66EC((userId) => single(projectId, userId), owner.UserId, [owner.UserId]);
    const disciplineFetched = useFeliz_React__React_useOptionalFetch_Static_5B82200F((disciplineId) => single_1(projectId, disciplineId), owner.DisciplineId, [owner.DisciplineId]);
    const user_1 = (userFetched.tag === 3) ? "?" : ((userFetched.tag === 0) ? "..." : ((userFetched.tag === 1) ? "..." : userFetched.fields[0].Name));
    const discipline_1 = (disciplineFetched.tag === 3) ? "?" : ((disciplineFetched.tag === 0) ? "" : ((disciplineFetched.tag === 1) ? "..." : disciplineFetched.fields[0].Name));
    const children = ofArray([createElement("span", {
        children: [`${defaultArg(map(EPM_Domain_Events_Maturity__Maturity_ToProperString, owner.Maturity), "Overall")} ${discipline_1}`],
    }), createElement("span", {
        children: [user_1],
    })]);
    return createElement("li", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function systemOwners(projectId, systemOwners_1) {
    const children = map_1((owner) => createElement(SystemOwner, {
        projectId: projectId,
        owner: owner,
    }), systemOwners_1);
    return createElement("ul", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function rowRender(projectId, sys) {
    return new Row(sys.Id, ofArray([new Cell("name", sys.Name), new Cell("detail", sys.Detail), new Cell("status", defaultArg(map(toString, sys.Status), defaultOf())), new Cell("productionUnit", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(13, []),
        entityId: unwrap(sys.ProductionUnitId),
    })), new Cell("systemOwners", systemOwners(projectId, sys.SystemOwners)), new Cell("labels", createElement(Labels, {
        labels: sys.Labels,
    })), new Cell("lastModifiedOn", dateTimeCell(sys.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: sys.LastModifiedBy,
    }))]));
}

export function Systems(systemsInputProps) {
    let actions, systems, systems_1;
    const projectId = systemsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedSystems = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Systems",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (systemParams) => many(projectId, empty(), systemParams),
        fetchCount: (searchParams) => count(projectId, searchParams),
        rowRender: (sys) => rowRender(projectId, sys),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedSystems);
    const isMoreThan1 = length(selectedSystems) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Production Unit"], ["onClick", (_arg_3) => {
        setAction("assignProductionUnit");
    }], ["disabled", isEmpty(selectedSystems) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Status"], ["onClick", (_arg_4) => {
        setAction("assignStatus");
    }], ["disabled", isEmpty(selectedSystems) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Set System Owner"], ["onClick", (_arg_5) => {
        setAction("setSystemOwner");
    }], ["disabled", isEmpty(selectedSystems) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Remove System Owner"], ["onClick", (_arg_6) => {
        setAction("removeSystemOwner");
    }], ["disabled", isEmpty(selectedSystems) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_7) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedSystems) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Attributes"], ["onClick", (_arg_8) => {
        setAction("changeAttributes");
    }], ["disabled", isEmpty(selectedSystems) ? true : showDeleted]]))))), delay(() => (showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_9) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedSystems)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_10) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedSystems)]])))))))))))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedSystems) ? (isEmpty(tail(selectedSystems)) ? createElement(Update, {
        projectId: projectId,
        sys: head(selectedSystems),
        close: close,
    }) : undefined) : undefined) : ((actions === "assignProductionUnit") ? createElement(AssignProductionUnit, {
        projectId: projectId,
        systems: selectedSystems,
        close: close,
    }) : ((actions === "assignStatus") ? createElement(AssignStatus, {
        projectId: projectId,
        systems: selectedSystems,
        close: close,
    }) : ((actions === "setSystemOwner") ? createElement(SetSystemOwner, {
        projectId: projectId,
        systems: selectedSystems,
        close: close,
    }) : ((actions === "removeSystemOwner") ? createElement(RemoveSystemOwner, {
        projectId: projectId,
        systems: selectedSystems,
        close: close,
    }) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map_1((sys_1) => [new DomainEntity(6, [sys_1]), sys_1.Labels], selectedSystems),
        close: close,
    }) : ((actions === "changeAttributes") ? createElement(Components_ChangeAttributes, {
        projectId: projectId,
        entities: map_1((sys_2) => [new Entity(5, [sys_2]), sys_2.Attributes], selectedSystems),
        close: close,
    }) : ((actions === "delete") ? ((systems = map_1((Item) => (new DomainEntity(6, [Item])), selectedSystems), createElement(Components_Delete, {
        projectId: projectId,
        entities: systems,
        close: close,
    }))) : ((actions === "unDelete") ? ((systems_1 = map_1((Item_1) => (new DomainEntity(6, [Item_1])), selectedSystems), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: systems_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    }))))))))))) : undefined);
}

